import { Wrench, FileText, Calculator, Building2, ClipboardList, CalendarDays, Palette, Settings } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const FacilitiesMaintenanceIndustry = () => (
  <IndustryPlaceholderPage
    name="Facilities Maintenance"
    icon={Wrench}
    iconColor="text-info"
    iconBg="bg-[hsl(var(--info)/0.1)]"
    headline="Facilities Maintenance Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps facilities maintenance companies create professional service proposals, preventive maintenance plans, and long-term service contracts — all from one platform."
    valueProps={[
      { title: "Win Facility Contracts", description: "Build comprehensive maintenance proposals with service scopes, response times, and pricing that property managers trust." },
      { title: "Reduce Admin Time", description: "Generate detailed proposals with preventive maintenance schedules, vendor coordination plans, and equipment inventories in minutes." },
      { title: "Built for FM Companies", description: "Templates for HVAC, electrical, plumbing, general maintenance, and multi-site management — designed for the facilities industry." },
    ]}
    features={[
      { icon: Calculator, label: "Service Cost Calculators" },
      { icon: CalendarDays, label: "PM Scheduling" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: Building2, label: "Multi-Site Support" },
      { icon: Wrench, label: "Work Order Templates" },
      { icon: ClipboardList, label: "Asset Tracking" },
      { icon: Palette, label: "Custom Branding" },
      { icon: Settings, label: "SLA Management" },
    ]}
    benefits={[
      "Create facility-specific proposals with maintenance scopes, equipment lists, and response time SLAs",
      "Auto-calculate costs based on facility size, service frequency, and staffing requirements",
      "Generate branded proposals with floor plans and preventive maintenance calendars",
      "Send contracts with digital signatures for fast approval",
      "Track multi-site agreements, work orders, and service level compliance",
      "Support preventive, reactive, and emergency maintenance contracts",
    ]}
    proposalTemplates={[
      "Commercial Building Maintenance",
      "Multi-Site Facilities Management",
      "HVAC Maintenance Program",
      "Preventive Maintenance Plan",
      "Emergency Maintenance Services",
    ]}
    contractTemplates={[
      "Facilities Management Agreement",
      "Preventive Maintenance Contract",
      "Multi-Site Service Agreement",
      "Emergency Response Contract",
    ]}
    faq={[
      { q: "What is Sentinel Forge for facilities maintenance?", a: "Sentinel Forge is a proposal and contract platform for FM companies. It helps you build maintenance proposals, define SLAs, and send digital contracts to property managers and building owners." },
      { q: "Can I create proposals for different maintenance types?", a: "Yes. Templates cover HVAC, electrical, plumbing, general maintenance, janitorial coordination, and emergency services." },
      { q: "How does pricing calculation work?", a: "You define facility size, service scope, response times, and staffing. The system calculates total monthly and annual maintenance costs." },
      { q: "Can I manage multi-site contracts?", a: "Yes. You can create proposals and contracts that cover multiple facilities under a single agreement with site-specific scoping." },
      { q: "Do clients need an account to sign contracts?", a: "No. Clients receive a secure link to review and digitally sign contracts without creating an account." },
      { q: "Can I add my company's branding?", a: "Yes. Your logo, company name, and custom terms appear on every proposal and contract you generate." },
      { q: "When will facilities maintenance be available?", a: "We're building it now. Join the waitlist to get notified when the facilities maintenance module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to streamline your facilities business?"
    ctaDescription="Join FM companies preparing to automate maintenance proposals and service contracts with Sentinel Forge."
  />
);

export default FacilitiesMaintenanceIndustry;
